import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { postRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../CustomAlert';

const RouteDeleteModel = ({
  onShow,
  data,
  refreshData,
  setRouteDeleteModelShow,
  setRoutesModelShow,
}) => {
  const { access_token } = useSelector((state) => state.auth.user);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleClose = () => {
    setRouteDeleteModelShow(false);
    setRoutesModelShow(true);
  };

  const handleDelete = () => {
    postRequest(`/admin/sms-gateway-delete`, { id: data.id }, access_token.token, (res) => {
      if (res.success) {
        refreshData();
        handleClose();
        setAlertState({
          message: 'Successfully deleted a route',
          show: true,
          variant: 'success',
        });
      } else {
        setAlertState({
          message: res.message || 'There was an issue while deleting route',
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal show={onShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Route</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to delete <strong>{data.route_name}</strong>?
            <br />
            This action cannot be undone.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant={'danger'} onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RouteDeleteModel;
